import apiHeader from '@/helpers/apiHeader';

const workCenterService = {
  list(page, params) {
    return apiHeader.get('main-work-centers?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('main-work-centers/' + id);
  },
};

export default workCenterService;
